import * as analytics from 'utilities/analytics';
import {
  Avatar,
  Arrange,
  Button,
  Container,
  IconButton,
  Spacer,
  SvgClose,
  Text,
} from '@loomhq/lens';
import React from 'react';
import { CLOUDFRONT_URI } from 'constants/routes';

import { JOIN_WORKSPACE_BANNER_CLICKED } from 'constants/events';

interface JoinWorkspaceBannerProps {
  handleClose: () => void;
}

function JoinWorkspaceBanner({
  handleClose,
}: JoinWorkspaceBannerProps): JSX.Element {
  const { owner_name, ownerDomain, ownerOrganizationLogoPath, id } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.loomSSRVideo;

  function handleClick() {
    analytics.track(JOIN_WORKSPACE_BANNER_CLICKED);
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.location = `/signup-with-autojoin?ownerName=${owner_name}&ownerDomain=${ownerDomain}&videoId=${id}`;
  }

  const joinWorkspaceText = owner_name
    ? `Do you work with ${owner_name}? Join ${owner_name}'s workspace with your ${ownerDomain} email to start
  collaborating!`
    : `Do you work with this teammate? Join their workspace with your ${ownerDomain} email to start collaborating!`;

  return (
    <>
      <Container
        paddingX="medium"
        paddingY="small"
        backgroundColor="offWhite"
        radius="medium"
      >
        <Arrange justifyContent="space-between" gap="small">
          <Arrange justifyContent="end" gap="large">
            {ownerOrganizationLogoPath ? (
              <Avatar
                size={4}
                imageSrc={`${CLOUDFRONT_URI}/${ownerOrganizationLogoPath}`}
              />
            ) : null}
          </Arrange>
          <Text>{joinWorkspaceText}</Text>
          <Arrange justifyContent="end" gap="small">
            <Button onClick={handleClick}>Join workspace</Button>
            <IconButton
              altText="close"
              icon={<SvgClose />}
              size="medium"
              onClick={handleClose}
            />
          </Arrange>
        </Arrange>
      </Container>
      <Spacer bottom="medium" />
    </>
  );
}

export default JoinWorkspaceBanner;
